import { render } from "./DeletePaymentRecord.vue?vue&type=template&id=31f0c6ea&scoped=true"
import script from "./DeletePaymentRecord.vue?vue&type=script&lang=js"
export * from "./DeletePaymentRecord.vue?vue&type=script&lang=js"

import "./DeletePaymentRecord.vue?vue&type=style&index=0&id=31f0c6ea&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f0c6ea"]])

export default __exports__